import { ActionType, Property, PropertyType } from "../../../base/types"

import { FC } from "react"
import { IActionAttributes } from "../../../base/models"
import { MUIIcon } from "../../../widgets"
import { Registry } from "../../../base/register"
import clsx from "clsx"

export const ActionComponent: FC<IActionAttributes> = ({
    action, className
}) => {
    return (
        <div className={clsx(className, "d-flex px-5 py-2 gap-1")}>
            {action.icon && <MUIIcon iconName={action.icon} />}
            <span>{action.name}</span>
        </div>)
}

Registry.addAction({
    id: "486459b8-249e-45ef-bcc2-0a56c56443cc",
    name: "Action",
    type: ActionType.Action,
    properties: [
        { id: Property.PageLink, name: 'Page Link', type: PropertyType.PageLink },
    ],
    component: ActionComponent
})

Registry.addAction({
    id: "fa7bafbf-cb4a-4bbb-a5ca-1d907e8acd05",
    name: "Action Url",
    type: ActionType.ActionLink,
    properties: [
        { id: Property.Url, name: 'Page Url', type: PropertyType.String },
        { id: Property.Target, name: 'Target', type: PropertyType.String },
    ],
    component: ActionComponent
})

Registry.addAction({
    id: "b755de70-3e2d-47c5-8088-7d8d0585b1c8",
    name: "TOU Link",
    type: ActionType.TOULink,
    properties: [],
    component: ActionComponent
})

Registry.addAction({
    id: "43cadf60-c3a5-4421-a610-a049882369c0",
    name: "UMS Link",
    type: ActionType.UMSLink,
    properties: [],
    component: ActionComponent
})

Registry.addAction({
    id: "994ca77e-71f0-4fa6-abdd-84e438612f5c",
    name: "Portal Link",
    type: ActionType.PortalLink,
    properties: [
        { id: Property.Url, name: 'Page Url', type: PropertyType.String },
        { id: Property.Target, name: 'Target', type: PropertyType.String },
    ],
    component: ActionComponent
})